import React, { createContext, useContext, useMemo } from 'react'

const UserIsDataAdmin = createContext()

export const useUserIsDataAdmin = () => {
  const context = useContext(UserIsDataAdmin)
  if (!context) throw new Error('You need to use the DataAdminProvider to use the useUserIsDataAdmin')
  return context
}

export default function DataAdminProvider({ children, dataAdminRole }) {
  const isDataAdmin = useMemo(
    () => ({ userIsDataAdmin: Boolean(dataAdminRole?.match(/^Data Admin [4-6]$/i)) }),
    [dataAdminRole]
  )

  return <UserIsDataAdmin.Provider value={isDataAdmin}>{children}</UserIsDataAdmin.Provider>
}
